import React, { useEffect, useRef } from "react";

export const CursorGlow = () => {
  const ref = useRef(null);
  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const el = ref.current;
    let raf = 0, x = -500, y = -500;
    const move = (e) => { x = e.clientX; y = e.clientY; if (!raf) raf = requestAnimationFrame(paint); };
    const paint = () => { raf = 0; if (el) el.style.transform = `translate3d(${x - 200}px, ${y - 200}px, 0)`; };
    window.addEventListener("pointermove", move, { passive: true });
    return () => { window.removeEventListener("pointermove", move); cancelAnimationFrame(raf); };
  }, []);
  return <div ref={ref} aria-hidden="true" className="cursor-glow" />;
};

export const ScrollProgress = () => {
  const ref = useRef(null);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const p = h.scrollHeight - h.clientHeight;
      if (ref.current) ref.current.style.transform = `scaleX(${p > 0 ? h.scrollTop / p : 0})`;
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <div ref={ref} aria-hidden="true" data-testid="scroll-progress" className="scroll-progress" />;
};
